import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahClaimStatuses } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { SahClaimStatus } from '~lookups/models';

export const sahClaimStatusesApi = createApi({
  reducerPath: 'sahClaimStatusesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahClaimStatuses }),
  tagTypes: ['sah-claim-statuses'],
  endpoints: (builder) => ({
    getSahClaimStatuses: builder.query<SahClaimStatus[], Request | void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: [{ type: 'sah-claim-statuses', id: 'LIST' }],
      transformResponse: (payload) => unwrap<SahClaimStatus[]>(payload),
    }),
    getSahClaimStatus: builder.query<SahClaimStatus, string>({
      query: (id) => ({ url: `/${id}`, method: 'GET' }),
      providesTags: (_result, _error, id) => [{ type: 'sah-claim-statuses', id }],
      transformResponse: (payload) => unwrap<SahClaimStatus>(payload),
    }),
  }),
});

export const { useGetSahClaimStatusesQuery, useGetSahClaimStatusQuery } = sahClaimStatusesApi;
